import { render, staticRenderFns } from "./FooterInformationView.vue?vue&type=template&id=62bf5ac3"
import script from "./FooterInformationView.vue?vue&type=script&lang=ts"
export * from "./FooterInformationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports